import { useEffect, useState } from "react";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import Title from "../../components/title";
import { getSingleLanding } from "../../services/about/about.service";
import styles from "./Landing.module.css";

const Landing = ({ match }) => {
  let [content, setContent] = useState({});
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  useEffect(() => {
    const id = match.params.id;
    getSingleLanding(id).then(({ data }) => {
      setContent(data?.data[0]);
      setBreadCrumbItems([
        { title: "خانه", url: "/" },
        {
          title: (data && data?.data && data?.data[0]?.title) || "صفحه ویژه",
          url: "/landing/" + id,
        },
      ]);
    });
  }, [match.params.id]);
  return (
    <>
      <Title title={(content && content.title) || ""} />
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <BreadCrumb items={breadCrumbItems} />
          </div>
        </div>
        {content ? (
          <div
            id={styles.mainLandingContent}
            dangerouslySetInnerHTML={{ __html: content.rich_description }}
          ></div>
        ) : (
          <div className="loading-wrapper">
            <img
              src={"../../../assets/image/loading.svg"}
              alt={"در حال بار گذاری"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Landing;
